import API from "@/api/lib/api";

export const getAllComboMeals = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/combos`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleComboMeal = async (item_id) => {
  try {
    const response = await API.get(`restaurant/combos/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createComboMeal = async (data) => {
  try {
    const response = await API.post(`restaurant/combos`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateComboMeal = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/combos/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteComboMeal = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/combos/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
